// @flow

import { isFunction } from 'lodash';

// See fullstory.html for details about when FS gets installed for a user.
export const isFullStoryInstalled = () =>
  !!window.FS && isFunction(window.FS.identify);

export const identifyToFullStory = (
  id: string,
  userVars: { [string]: any }
) => {
  if (!isFullStoryInstalled()) {
    return; // bail silently, we don't want to throw an error here
  }

  window.FS.identify(id, userVars);
};

// Note that custom vars need to be type-suffixed (e.g. _str for strings).
// See "Custom fields" section of this doc for more info: https://help.fullstory.com/develop-js/setuservars
export const setFullStoryUserVars = (userVars: { [string]: any }) => {
  if (!isFullStoryInstalled()) {
    return; // bail silently, we don't want to throw an error here
  }

  window.FS.setUserVars(userVars);
};

// Note that both 'eventName' and 'eventProperties' here must conform to FullStory's requirements,
// otherwise your event will be silently rejected! The requirements are discussed here:
// https://help.fullstory.com/develop-js/363565-fs-event-api-sending-custom-event-data-into-fullstory#Limitations%20&%20Guidelines
export const sendFullStoryEvent = (
  eventName: string,
  eventProperties: { [string]: any } = {}
) => {
  if (!isFullStoryInstalled()) {
    return; // bail silently, we don't want to throw an error here
  }

  window.FS.event(eventName, eventProperties);
};
